import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AdminTable from '../../common/AdminTable';
import { getLiveVideoRequest, deleteLiveVideoRequest } from '../../slice/liveVideoSlice';
import { AiOutlinePlus } from 'react-icons/ai';
import { toast } from 'react-toastify';

const getVideoUrl = (videoFile) => {
    if (!videoFile) return null;
    if (/^https?:\/\//i.test(videoFile)) return videoFile;

    const backendBase = (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, '');
    if (!backendBase) return videoFile;

    const normalizedPath = String(videoFile).replace(/^\/+/, '');
    if (normalizedPath.startsWith('uploads/')) {
        return `${backendBase}/${normalizedPath}`;
    }
    return `${backendBase}/uploads/videos/${normalizedPath}`;
};

const LiveVideoList = () => {
    const dispatch = useDispatch();
    const { liveVideos, loading } = useSelector((state) => state.liveVideo);

    useEffect(() => {
        dispatch(getLiveVideoRequest());
    }, [dispatch]);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this video?")) {
            dispatch(deleteLiveVideoRequest(id));
            toast.success("Deleting video...");
        }
    };

    const tableHeaders = [
        { Header: 'S.No', accessor: 'id' },
        { Header: 'Name', accessor: 'name' },
        { 
            Header: 'Source', 
            Cell: ({ row }) => row.original.youtube_url ? <span className="badge badge-info">YouTube</span> : <span className="badge badge-success">File</span>
        },
        { 
            Header: 'Content', 
            Cell: ({ row }) => {
                if (row.original.youtube_url) {
                    return (
                        <a href={row.original.youtube_url} target="_blank" rel="noopener noreferrer">
                            {row.original.youtube_url}
                        </a>
                    );
                }
                const videoUrl = getVideoUrl(row.original.video_file);
                return videoUrl ? (
                    <video
                        src={videoUrl}
                        controls
                        width={220}
                        preload="metadata"
                        style={{ borderRadius: '4px' }}
                    >
                        <track kind="captions" />
                    </video>
                ) : (
                    <span className="text-muted">—</span>
                );
            }
        },
        { 
            Header: 'Status', 
            Cell: ({ row }) => (
                <span className={`badge ${row.original.status === 'active' ? 'badge-success' : 'badge-danger'}`}>
                    {row.original.status}
                </span>
            )
        },
        {
            Header: 'Actions',
            Cell: ({ row }) => (
                <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.original.id)}>Delete</button>
                </div>
            )
        }
    ];

    return (
        <div className="container-fluid px-4">
            <div className='d-flex justify-content-between align-items-center my-4'>
                <h2 className='m-0'>Live Videos</h2>
                <Link to="/live-video/add" className='btn btn-primary d-flex align-items-center gap-2'>
                    <AiOutlinePlus /> Add New Video
                </Link>
            </div>

            <div className='card shadow mb-4'>
                <div className='card-body p-0'>
                    {loading ? (
                        <div className="text-center p-5">Loading...</div>
                    ) : (
                        <AdminTable 
                            tableHeaders={tableHeaders} 
                            tableData={liveVideos} 
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LiveVideoList;
